export default __webpack_public_path__ + "static/united-settlement-e355cd1a80aabafa4af0e4d90745c410.png";